// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/amateur-built-aircraft.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/amateur-built-aircraft/amateur-built-aircraft.js';

mount([g0]);
